(function() {
  const scope = document;
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const BEHAVIOR = prefersReduced ? 'auto' : 'smooth';
  const EPS = 8;

  function parseJSONAttr(el, attr){
    let raw = el.getAttribute(attr);
    if (!raw) return null;
    raw = raw
      .replaceAll('&quot;','"')
      .replaceAll('&#34;','"')
      .replaceAll('&apos;',"'")
      .replaceAll('&#39;',"'")
      .replaceAll('&amp;','&');
    try { return JSON.parse(raw); } catch(e){ return null; }
  }

  // 🔒 Legge l’altezza computata e la fissa in px (evita 1px→2px)
  function freezeHeight(el){
    if (!el) return;
    const h = parseFloat(getComputedStyle(el).height || '0');
    if (h > 0) el.style.height = Math.round(h) + 'px';
  }

  function initOne(card){
    const media = card.querySelector('.card__media') || card;
    if (!media) return;

    const images = parseJSONAttr(card, 'data-gallery') || [];
    const count  = Array.isArray(images) ? images.filter(Boolean).length : 0;

    // Se 0/1 immagini: rimuovi eventuale slider e stop
    const mounted = media.querySelector('.obs-mini-slider');
if (count <= 1) {
  if (mounted) {
    mounted._obsCleanup && mounted._obsCleanup();
    mounted.remove();
  }
  return;
}
    // Evita doppio mount
    // Evita doppio mount — ma se esiste senza cleanup, rimuovilo e ricrea
if (mounted) {
  if (!mounted._obsCleanup) {
    // mount incrinato: rimuovilo e continua
    mounted.remove();
  } else {
    return;
  }
}

    // ===== DOM base =====
const wrap  = document.createElement('div'); wrap.className = 'obs-mini-slider';
const track = document.createElement('div'); track.className = 'obs-track';
wrap.appendChild(track);
track.style.visibility = 'hidden';

// container per teardown (DEVE esistere PRIMA di qualsiasi cleanups.push)
const cleanups = [];

    images.forEach((url) => {
      const s = document.createElement('div'); s.className = 'obs-slide';
      const img = document.createElement('img');
      img.loading='lazy'; img.decoding='async'; img.alt = card.dataset.productTitle || '';
      img.src = url;
      s.appendChild(img);
      track.appendChild(s);
    });

    // Frecce + cloni
    const prev = document.createElement('button');
    prev.type='button'; prev.className='obs-nav obs-nav--prev';
    prev.setAttribute('aria-label','Immagine precedente');
    prev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#b595ce" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';

    const next = document.createElement('button');
    next.type='button'; next.className='obs-nav obs-nav--next';
    next.setAttribute('aria-label','Immagine successiva');
    next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#b595ce" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

    wrap.appendChild(prev); wrap.appendChild(next);

    const first = track.firstElementChild.cloneNode(true); first.dataset.clone='1';
    const last  = track.lastElementChild.cloneNode(true);  last.dataset.clone='1';
    track.insertBefore(last, track.firstChild);
    track.appendChild(first);

    // --- SCROLLBAR / progress ---
    let progress = null;
    {
      const bar = document.createElement('div');
      bar.className = 'obs-scrollbar';
      bar.setAttribute('role','presentation');
      bar.style.opacity = '1'; // nascosta finché non fissiamo l’altezza

      const knob = document.createElement('button');
      knob.type='button';
      knob.className = 'obs-scrollbar__knob';
      knob.setAttribute('aria-label', 'Selettore immagine');
      knob.setAttribute('role','slider');
      knob.setAttribute('aria-valuemin','1');
      knob.setAttribute('aria-valuemax', String(count));
      knob.setAttribute('aria-valuenow','1');
      knob.style.opacity = '1';

      bar.appendChild(knob);
      wrap.appendChild(bar);

      const stepPct = 100 / count;
      let dragging = false;
      let dragPointerId = null;
      let dragOffset = 0;

      const setWidth = () => { knob.style.width = stepPct + '%'; };

      const realIndex = () => {
        if (!w) return 1;
        let n = Math.round(track.scrollLeft / w);
        if (n <= 0) return count;
        if (n >= count+1) return 1;
        return n;
      };

      const position = () => {
  if (isInit) return; // ⛔ BLOCCO TOTALE IN INIT

  const idx = realIndex();
  knob.style.left = ((idx - 1) * stepPct) + '%';
  knob.setAttribute('aria-valuenow', String(idx));
};


      function pctToLeft(pct){
        const frac = Math.min(1, Math.max(0, pct / 100));
        return (1 + frac * (count - 1)) * (w || 0);
      }

      function pointerToPct(clientX){
        const r = bar.getBoundingClientRect();
        const knobRect = knob.getBoundingClientRect();
        const x = Math.min(r.right, Math.max(r.left, clientX - (dragging ? dragOffset : knobRect.width/2)));
        const frac = (x - r.left) / r.width;
        return frac * 100;
      }

      function jumpToPct(pct, smooth){
        const left = pctToLeft(pct);
        teleporting = true;
        track.scrollTo({ left: Math.round(left), behavior: smooth ? BEHAVIOR : 'auto' });
        teleporting = false;
        position();
      }

      function snapToNearest(){
        const idx = realIndex();
        teleportTo(idx * (w || 0));
      }

      const onPointerDown = (e) => {
        dragging = true;
        dragPointerId = e.pointerId || null;
        const knobRect = knob.getBoundingClientRect();
        dragOffset = (e.clientX || 0) - knobRect.left;
        knob.setPointerCapture && dragPointerId && knob.setPointerCapture(dragPointerId);
        userDraggingKnob = true;
        e.preventDefault();
      };
      const onPointerMove = (e) => { if (dragging) jumpToPct(pointerToPct(e.clientX || 0), false); };
      const onPointerUp   = () => {
        if (!dragging) return;
        dragging = false;
        dragPointerId && knob.releasePointerCapture && knob.releasePointerCapture(dragPointerId);
        dragPointerId = null;
        userDraggingKnob = false;
        snapToNearest();
      };

     const barPointerDown = (e) => {
  if (e.target === knob) return;
  jumpToPct(pointerToPct(e.clientX || 0), true);
  setTimeout(snapToNearest, 120);
};
bar.addEventListener('pointerdown', barPointerDown, { passive: false });
cleanups.push(() => bar.removeEventListener('pointerdown', barPointerDown));

knob.addEventListener('pointerdown', onPointerDown, { passive: false });

// usa pointermove/up sul knob (pointer capture invierà gli eventi qui mentre è catturato)
const knobMoveHandler = (e) => { if (dragging) jumpToPct(pointerToPct(e.clientX || 0), false); };
const knobUpHandler   = onPointerUp;

knob.addEventListener('pointermove', knobMoveHandler, { passive: true });
knob.addEventListener('pointerup', knobUpHandler, { passive: true });
knob.addEventListener('pointercancel', knobUpHandler, { passive: true });

// registra teardown
cleanups.push(() => {
  knob.removeEventListener('pointerdown', onPointerDown);
  knob.removeEventListener('pointermove', knobMoveHandler);
  knob.removeEventListener('pointerup', knobUpHandler);
  knob.removeEventListener('pointercancel', knobUpHandler);
});

      const knobKeydown = (e) => {
  if (!w) return;
  if (e.key === 'ArrowLeft')  { e.preventDefault(); track.scrollBy({ left: -w, behavior: BEHAVIOR }); }
  if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left:  w, behavior: BEHAVIOR }); }
  if (e.key === 'Home')       { e.preventDefault(); teleportTo(w); }
  if (e.key === 'End')        { e.preventDefault(); teleportTo(count * w); }
};
knob.addEventListener('keydown', knobKeydown);
cleanups.push(() => knob.removeEventListener('keydown', knobKeydown));

      setWidth();
      progress = { position, setWidth, knob, bar };
    }

    // Layering + mount
    media.style.position = media.style.position || 'relative';
    wrap.style.position  = 'absolute';
    wrap.style.inset     = '0';
    wrap.style.zIndex    = '6';
    wrap.style.pointerEvents = 'auto';
    media.appendChild(wrap);
wrap.dataset.obsSlider = '1';

// === cleanup container per evitare memory leak ===
wrap._obsCleanup = () => {
  while (cleanups.length) {
    const fn = cleanups.pop();
    try { fn(); } catch(e){ /* ignore */ }
  }
  try { if (typeof ro !== 'undefined' && ro && ro.disconnect) ro.disconnect(); } catch(e){}
};

    // ---- logica stabile ----
    let w = 0;
    let maxLeft = 0;
    let teleporting = false;
    let snapTimer = null;
    let userDraggingKnob = false;
    let isInit = true;

    let animRaf = 0, animating = false;
    const easeOutCubic = t => 1 - Math.pow(1 - t, 3);
    function animateTo(left, duration = prefersReduced ? 0 : 420){
      cancelAnimationFrame(animRaf);
      const start = track.scrollLeft;
      const delta = Math.round(left) - start;
      if (Math.abs(delta) < 1 || duration === 0){ teleportTo(left); return; }
      animating = true;
      const t0 = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - t0) / duration);
        const eased = easeOutCubic(t);
        teleporting = true;
        track.scrollLeft = start + delta * eased;
        teleporting = false;
        if (progress) progress.position();
        if (t < 1) { animRaf = requestAnimationFrame(step); }
        else { animating = false; teleportTo(Math.round(left)); }
      };
      animRaf = requestAnimationFrame(step);
    }

    function lockWidthsAndMeasure(){
      const wpx = Math.round(media.getBoundingClientRect().width || track.clientWidth || 0);
      if (!wpx) return false;

      track.querySelectorAll('.obs-slide').forEach(s => {
        s.style.flex = `0 0 ${wpx}px`;
        s.style.width = `${wpx}px`;
        s.style.minWidth = `${wpx}px`;
        s.style.maxWidth = `${wpx}px`;
        s.style.boxSizing = 'border-box';
      });

      track.style.transform = 'translateZ(0)';
      track.style.display = 'flex';
      track.style.overflowX = 'auto';
      track.style.overflowY = 'hidden';
      track.style.scrollSnapType = 'x mandatory';

      w = wpx;
      maxLeft = Math.max(0, track.scrollWidth - track.clientWidth);
      if (progress) { progress.setWidth(); progress.position(); }
      return true;
    }

    const atStart = () => track.scrollLeft <= EPS;
    const atEnd   = () => track.scrollLeft >= (maxLeft - EPS);

    function teleportTo(left){
      teleporting = true;
      const prevSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.scrollTo({ left: Math.round(left), behavior: 'auto' });
      requestAnimationFrame(() => {
        track.style.scrollSnapType = prevSnap || 'x mandatory';
        teleporting = false;
        if (progress) progress.position();
      });
    }

    function onScroll(){
       if (isInit) return;
      if (teleporting || !w) return;

      if (count > 1) {
        if (atStart()) { teleportTo(Math.max(0, maxLeft - w)); return; }
        if (atEnd())   { teleportTo(w); return; }
      }

      if (progress) progress.position();
      if (userDraggingKnob) return;

      clearTimeout(snapTimer);
      snapTimer = setTimeout(() => {
        const idx = Math.round(track.scrollLeft / w);
        teleportTo(idx * w);
      }, 90);
    }

    // Frecce
    const prevBtn = wrap.querySelector('.obs-nav--prev');
    const nextBtn = wrap.querySelector('.obs-nav--next');
   if (prevBtn) {
  const prevHandler = (e) => { e.preventDefault(); e.stopPropagation(); if (!w && !lockWidthsAndMeasure()) return; track.scrollBy({ left: -w, behavior: BEHAVIOR }); };
  prevBtn.addEventListener('click', prevHandler);
  cleanups.push(() => prevBtn.removeEventListener('click', prevHandler));
}
if (nextBtn) {
  const nextHandler = (e) => { e.preventDefault(); e.stopPropagation(); if (!w && !lockWidthsAndMeasure()) return; track.scrollBy({ left: w, behavior: BEHAVIOR }); };
  nextBtn.addEventListener('click', nextHandler);
  cleanups.push(() => nextBtn.removeEventListener('click', nextHandler));
}

    const mediaKeyHandler = (e) => {
  if (e.key === 'ArrowLeft')  { e.preventDefault(); if (!w && !lockWidthsAndMeasure()) return; track.scrollBy({ left: -w, behavior: BEHAVIOR }); }
  if (e.key === 'ArrowRight') { e.preventDefault(); if (!w && !lockWidthsAndMeasure()) return; track.scrollBy({ left: w, behavior: BEHAVIOR }); }
};
media.addEventListener('keydown', mediaKeyHandler);
cleanups.push(() => media.removeEventListener('keydown', mediaKeyHandler));


    track.addEventListener('scroll', onScroll, { passive: true });
    cleanups.push(() => track.removeEventListener('scroll', onScroll));

    // Kick iniziale (dopo assestamento)
    const MODAL_SETTLE_MS = 600;
    (function kick(){
      const sinceOpen = ((window.performance && performance.now()) || Date.now()) - (window.__OBS_SEARCH_OPEN_TS || 0);
      if (sinceOpen < MODAL_SETTLE_MS) { setTimeout(kick, MODAL_SETTLE_MS - sinceOpen); return; }
      if (!lockWidthsAndMeasure()) { requestAnimationFrame(kick); return; }

      teleporting = true;
track.scrollLeft = w; // vai alla prima reale SENZA trigger
teleporting = false;

requestAnimationFrame(() => {
  track.style.visibility = 'visible'; // 🔓 ora può apparire
  isInit = false;                      // 🔓 sblocca scroll

  if (progress) {
    progress.position();
    freezeHeight(progress.bar);
    freezeHeight(progress.knob);
    progress.bar.style.opacity  = '1';
    progress.knob.style.opacity = '1';
  }
});
})();

    // ResizeObserver con debounce
    let roTimer = 0;
    const ro = new ResizeObserver(() => {
  clearTimeout(roTimer);
  roTimer = setTimeout(() => {
    const oldIdx = Math.round(track.scrollLeft / (w || 1));
    if (lockWidthsAndMeasure()) teleportTo(oldIdx * w);
  }, 120);
});
ro.observe(media);
cleanups.push(() => { try { ro.disconnect(); } catch(e){} });
  }

  function init(){
    scope.querySelectorAll('.card-wrapper.obs-card[data-gallery]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('facets:updated', init);
  new MutationObserver(()=>init()).observe(document.documentElement,{childList:true,subtree:true});
})();

